import { useEffect } from 'react';
import { Hero } from '@/components/home/hero';
import { Features } from '@/components/home/features';
import { ServiceOverview } from '@/components/home/service-overview';
import { BeforeAfter } from '@/components/home/before-after';
import { TeamSection } from '@/components/home/team-section';
import { Impact } from '@/components/home/impact';
import { PremiumSpaces } from '@/components/home/premium-spaces';
import { Testimonials } from '@/components/home/testimonials';
import { MedicalShowcase } from '@/components/home/medical-showcase';
import { CTA } from '@/components/home/cta';
import { ContactSection } from '@/components/home/contact-section';
import { useDocumentHead } from '@/hooks/use-document-head';

export default function HomePage() {
  useDocumentHead(
    'Orlando Cleaning Services | Sonz of Thunder Services',
    'Residential & commercial cleaning across Orlando & Central Florida from Sonz of Thunder Services (SOTSVC). Licensed, insured, free quotes.',
  );
  useEffect(() => {
    const els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('on');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="min-h-screen">
      <Hero />
      <Features />
      <ServiceOverview />
      <BeforeAfter />
      <TeamSection />
      <Impact />
      <PremiumSpaces />
      <Testimonials />
      <MedicalShowcase />
      <CTA />
      <ContactSection />
    </div>
  );
}
